import { create } from 'zustand';
import { fetchAuditLogs } from '../api';
import { useErrorStore } from './useErrorStore';

export interface AuditLog {
  id: number;
  action: string;
  table_name: string;
  row_id: string;
  changed_by: string;
  changed_at: string;
  changed_data: string;
}

interface AuditLogsState {
  auditLogs: AuditLog[];
  loading: boolean;
  refresh: (start?: string, end?: string) => Promise<void>;
}

export const useAuditLogsStore = create<AuditLogsState>((set) => ({
  auditLogs: [],
  loading: false,
  refresh: async (start?: string, end?: string) => {
    set({ loading: true });
    try {
      const now = new Date();
      const past = new Date();
      past.setDate(now.getDate() - 30);
      const startDate = start ?? past.toISOString().split('T')[0];
      const endDate = end ?? now.toISOString().split('T')[0];
      const data = await fetchAuditLogs(startDate, endDate);
      set({ auditLogs: Array.isArray(data) ? data : [], loading: false });
    } catch (error) {
      useErrorStore.getState().setError('Failed to fetch audit logs.');
      set({ loading: false });
    }
  },
}));
